import React, { Component } from 'react';
import styled from 'styled-components';

import jobs from './jobsList';

const ShowMoreButton = styled.button`
  margin: 0 auto;
  padding: 0 1rem;
  list-style: none;

  display: block;
  text-align: center;
  font-size: .8rem;
  line-height: 2.7;
  border-radius: 2px;
  border: 2px solid;
  border-color: transparent;

  background: #1e50ca;
  color: white;

  &:hover {
    background: transparent;
    color: currentColor;
    border-color: #ededed;
  }

  @media (min-width: 1200px) {
    font-size: 1rem;
    line-height: 2.6;
    border-radius: 3px;
  }
`

const Timeline = styled.div`
  border-left-width: 2px;
  border-left-style: solid;
  border-color: #ececec;
  margin-left: calc(1rem - 2px);
  padding-left: 25px;
  padding-bottom: 1rem;
  position: relative;
`

const createDescription = description => ({
  __html: description,
})

export class Jobs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      areAllJobsVisible: false,
    }
  }

  showAllJobs = () => {
    this.setState({ areAllJobsVisible: true })
  }

  render() {
    let jobsList = jobs;
    if (!this.state.areAllJobsVisible) {
      jobsList = jobs.slice(0, 3);
    }

    return (
      <section className="o-section  t-section  ">

        <div className="o-section__header-bg  t-section__header"></div>
        <div className="o-section__content-bg  t-section__content"></div>

        <div className="o-container">
          <div className="o-section__container">

            <header className="o-section__header  t-section__header">
              <div className="o-content">
                <h2 className="o-section__heading">Work experience</h2>
              </div>
            </header>

            <div className="o-section__content  t-section__content  u-pb-0">

              <Timeline>
                { jobsList.map(job => (
                  <div className="c-timeline__item" key={job.period}>
                    <div className="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                    <div className="o-content">
                      <div className="o-grid">
                        <div className="o-grid__col-md-5">
                          <div className="c-work__timeframe">{job.period}</div>
                          <h3 className="c-work__heading">{job.role}</h3>
                          <h4 className="c-work__title">
                            {!!job.company.url && (
                              <a href={job.company.url} target="_blank" rel="noopener noreferrer" name={`External link to ${job.company.name}`}>{job.company.name}</a>
                            )}
                            {!job.company.url && job.company.name}
                          </h4>
                          <div className="c-work__location">{job.location}</div>
                        </div>
                        <div className="o-grid__col-md-7" dangerouslySetInnerHTML={createDescription(job.description)} />
                      </div>
                    </div>
                  </div>
                )) }

                {!this.state.areAllJobsVisible && <ShowMoreButton onClick={this.showAllJobs}>Show previous roles</ShowMoreButton>}

              </Timeline>

            </div>

          </div>
        </div>

      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Jobs/Jobs.js